import { IPickerAspectOption } from '@rbi-ctg/menu';

export function getTitleText(
  pickerName: string,
  pickerAspectOptions?: IPickerAspectOption[]
): string {
  if (!pickerAspectOptions) {
    return pickerName;
  }

  const joinedOptionNames = pickerAspectOptions
    .filter(o => !o.hideNameInItemPreview)
    .map(o => o.name?.locale)
    .join(' ');
  return `${pickerName} ${joinedOptionNames}`;
}
